<template>
    <div>
        <div class="row">
            <div class="col-md-5">
                <v-autocomplete :items="days" multiple outlined v-model="times.day" label="روزهای هفته" dense
                                clear-icon="mdi-close-circle-outline" item-text="day" item-value="value"
                                append-inner-icon="fa fa-pencil-alt">
                </v-autocomplete>
            </div>
            <div class="col-md-5">
                <date-picker v-model="times.start" type="time"
                             format="HH:mm"
                             display-format="HH:mm"
                             :timezone="false"
                             auto-submit
                             label="ساعت شروع"
                             endTime></date-picker>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5">
                <date-picker v-model="times.end" type="time"
                             format="HH:mm"
                             display-format="HH:mm"
                             :timezone="false"
                             auto-submit
                             label="ساعت پایان"
                             endTime></date-picker>
            </div>
            <!--            <div class="col-md-6">-->
            <!--                <v-text-field min="1" max="12" v-model.number="times.repeat"-->
            <!--                              oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"-->
            <!--                              type="number" outlined label="تعداد تکرار هفته ها " dense-->
            <!--                              clear-icon="mdi-close-circle-outline"-->
            <!--                              append-inner-icon="fa fa-pencil-alt">-->
            <!--                </v-text-field>-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
import {Bus} from "@/main";
import Swal from "sweetalert2";

export default {
    name: "timrWithDays",
    props: {
        autoGradual: {
            default: false
        }
    },
    data() {
        return {
            nowTime: '',

            times: {
                end: '',
                day: '',
                start: '',
                repeat: ''
            },
            days: [
                {day: 'شنبه', value: '0',},
                {day: 'یکشنبه', value: '1',},
                {day: 'دوشنبه', value: '2',},
                {day: 'سه شنبه', value: '3',},
                {day: 'چهارشنبه', value: '4',},
                {day: 'پنجشنبه', value: '5',},
                {day: 'جمعه', value: '6',},
            ]
        }
    },
    methods: {
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                fn: this.getTimesForNow,
                type: 'GET',
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.nowTime = data.data.time_stamp;
                }
            });
        }
    },
    watch: {
        times: {
            handler: function () {
                Bus.$emit('getDayMode', this.times)
            },
            deep: true
        },
    },
    mounted() {
        this.getTimesForNow()
    }
}
</script>

<style scoped>

</style>